import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import { GX_MAIN_BACKGROUND, GX_TILE_LIGHT } from '@/constants/colors';
import { spacing } from '@/constants/ui';
import Button from '@/shared/ui/primitives/Button';
import GoLogo from '@/shared/ui/primitives/GoLogo';
import { SupportContact } from '@/shared/ui/primitives/SupportContact';

export type FullPageMessageProps = {
  title: string;
  subtitle: string;
  buttonLabel: string;
  onButtonClick: () => void;
};

export const FullPageMessage = ({
  title,
  subtitle,
  buttonLabel,
  onButtonClick
}: FullPageMessageProps) => (
  <Box
    sx={{
      backgroundImage: `linear-gradient(244deg, ${GX_TILE_LIGHT} 0%, ${GX_MAIN_BACKGROUND} 99.27%) !important`,
      width: 'fit-content',
      minWidth: '100%'
    }}
  >
    <Box
      sx={{
        minHeight: '100vh',
        height: '100%',
        minWidth: '300px',
        display: 'flex',
        justifyContent: 'center',
        p: 4
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          mt: '4vh'
        }}
      >
        <GoLogo size={74} />
        <Typography
          sx={{ textAlign: 'center', mt: spacing[4] }}
          variant='h1'
        >
          {title}
        </Typography>
        <Typography
          sx={{ my: spacing[2], maxWidth: 500, textAlign: 'center' }}
          variant='subtitle1'
        >
          {subtitle}
        </Typography>
        <Button
          sx={{
            width: 250,
            mb: spacing[3]
          }}
          variant='contained'
          onClick={onButtonClick}
        >
          {buttonLabel}
        </Button>
        <SupportContact sx={{ textAlign: 'center' }} />
      </Box>
    </Box>
  </Box>
);
